/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const STATUS_CREATED = 10;
const STATUS_DATA_COMPLETED = 20;
const STATUS_CHECKED = 30;
const STATUS_ORDERED = 40;
const STATUS_PAID = 50;
const STATUS_COMPLETED = 60;

export { STATUS_CREATED, STATUS_DATA_COMPLETED, STATUS_CHECKED, STATUS_ORDERED, STATUS_PAID, STATUS_COMPLETED };
